import {
  compose,
  lifecycle,
  withProps,
  withHandlers,
  withState,
} from "recompose";
import { withApollo } from "react-apollo";
import websiteConfig from "config/website";

/**
 * If unfocused during at least INACTIVITY_TIMEOUT milliseconds, trigger
 * refresh on next focus.
 */
const INACTIVITY_TIMEOUT = websiteConfig.inactivityTimeout || 1800000;

const EnhanceAppRouter = compose(
  // See: https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API#Example
  withProps((props) => {
    if (typeof document.msHidden !== "undefined") {
      return {
        hidden: "msHidden",
        visibilityChange: "msvisibilitychange",
      };
    } else if (typeof document.webkitHidden !== "undefined") {
      return {
        hidden: "webkitHidden",
        visibilityChange: "webkitvisibilitychange",
      };
    }
    return {
      hidden: "hidden",
      visibilityChange: "visibilitychange",
    };
  }),
  withApollo,
  withState("lastFocus", "setLastFocus", null),
  withHandlers({
    handleVisibilityChange: (props) => (event) => {
      if (document[props.hidden]) {
        props.setLastFocus(Date.now());
      } else if (
        props.lastFocus !== null &&
        Date.now() > props.lastFocus + INACTIVITY_TIMEOUT
      ) {
        window.location.reload();
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      document.addEventListener(
        this.props.visibilityChange,
        this.props.handleVisibilityChange,
        false
      );
    },
    componentWillUnmount() {
      document.removeEventListener(
        this.props.visibilityChange,
        this.props.handleVisibilityChange,
        false
      );
    },
  })
);

export default EnhanceAppRouter;
